module.exports = __webpack_public_path__ + "img/icons_10.73b27855.svg";